<template>
  <div>
    <Card>
      <ui-period-picker-input
        :label="t('Update Period')"
        :value="[form.startTimestamp, form.endTimestamp]"
        :time-in-title="false"
        :hide-details="2"
      ></ui-period-picker-input>
    </Card>
    <Card>
      <ui-period-picker-input
        :label="t('Update Period')"
        :value="[form.startTimestamp, form.endTimestamp]"
        :start-timestamp-errors="'startTimestamp'"
        :end-timestamp-errors="'endTimestamp'"
        :time-in-title="true"
        :hide-details="2"
      ></ui-period-picker-input>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

import { reactive } from 'vue';
import { useI18n } from '@/composables';

const { t } = useI18n();

const form = reactive({
  startTimestamp: new Date(),
  endTimestamp: new Date(),
});
</script>
